<template>
    <div class="footer">
        <div class="row">
            <div class="col-sm-3 col-sm-6 col-lg-3 foorer-e-namad">
                <div class="d-flex footer-license-titr justify-content-center">
                    <h6 class="font-size-20">مجوزها</h6>
                </div>
                <div class="foorer-e-namad-img d-flex justify-content-center">
                    <!-- <img src="@/assets/images/home/namad.jpg" alt=""> -->
                    <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=184461&amp;Code=TjcFdhiKES5ms6jDtDak">
                        <img referrerpolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=184461&amp;Code=TjcFdhiKES5ms6jDtDak" alt="" style="cursor:pointer" id="TjcFdhiKES5ms6jDtDak">
                    </a>
                </div>
            </div>
            <div class="col-sm-2 col-sm-6  col-lg-2 footer-about d-flex">
                <div class="d-flex footer-about-titr">
                    <h6>درباره معلم یار</h6>
                </div>
                <div class="d-flex footer-about-contact">
                    <a href="">قوانین و مقررات</a>
                </div>
                <div class="d-flex footer-about-contact">
                    <a href="">همکاری با ما</a>
                </div>
                <div class="d-flex footer-about-contact">
                    <a href="">درباره معلم یار</a>
                </div>
            </div>
            <div class="col-sm-2 col-sm-12  col-lg-2 footer-network d-flex">
                <div class="d-flex footer-network-titr">
                    <h6>شبکه های اجتماعی</h6>
                </div>
                <div class="d-flex footer-network-icon">
                    <a class="icon-instagram"></a>
                    <a class="icon-linkedin2"></a>
                    <a class="icon-telegram"></a>
                </div>
                <!-- <div class="d-flex footer-network-icon">
                    <a class="icon-twiter-line"></a>
                    <a class="icon-facebook"></a>
                    <a class="icon-youtube"></a>
                </div> -->
                <!-- <div class="d-flex footer-network-icon">
                    <a class="icon-pinterest2"></a>
                    <a class="icon-aparat-line"></a>
                    <a class="icon-virgool-logo"></a>
                </div> -->
            </div>
            <div class="col-sm-4 col-sm-12  col-lg-4 footer-contact d-flex">
                <div class="d-flex footer-contact-titr">
                    <h6>تماس با ما </h6>
                </div>
                <div class="d-flex footer-contact-address mb-4">
                    <p>تهران، کیلومتر 20 جاده دماوند، پارک فناوری پردیس، نبش خیابان نوآوری، ساختمان فن بازار، طبقه اول واحد ۱۱۱۶</p>
                </div>
                <div class="d-flex footer-contact-suport">
                   <span>پشتیبانی : ۷۶۲۵۰۸۷۶ (۲۱) ۹۸+</span>
                   <!-- <span>مدیر سایت : ۲۲۶۴۷۱۴۳ (۲۱) ۹۸+</span>
                   <span>ایمیل : info@cityrakhsh.com</span> -->
                </div>

            </div>
            <div class="col-sm-12 footer-copy-right d-flex">
                <p>&copy;</p>
                <p>کلیه حقوق مادی و معنوی این سایت متعلق به شرکت راهکار خدمات شهر رخش می باشد.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Footer"
}
</script>